// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GuidEventLookupModel from '../../model/guid-event-lookup-model';
import GuidEventLookupDTO from '../dto/guid-event-lookup-dto';
import dtoSchema from '../schemas/guid-event-lookup-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class GuidEventLookupModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GuidEventLookupDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.caption = data.caption ?? undefined;
      this.details = data.details ?? undefined;
      this.sort = data.sort;
      this.isFeedbackEnabled = data.isFeedbackEnabled;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  caption?: string;
  /**
  */
  details?: string;
  /**
  * @type {int32}
  */
  sort?: number;
  /**
  */
  isFeedbackEnabled?: boolean;

  static toModel(dto: DeepPartial<GuidEventLookupDTO>): GuidEventLookupModel;
  static toModel(dto: DeepPartial<GuidEventLookupDTO> | undefined | null): GuidEventLookupModel | undefined;
  static toModel(dto: DeepPartial<GuidEventLookupDTO> | undefined | null): GuidEventLookupModel | undefined {
    return dto ? new GuidEventLookupModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GuidEventLookupModel> | GuidEventLookupModel): GuidEventLookupDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      caption: unwrapped.caption,
      details: unwrapped.details,
      sort: unwrapped.sort,
      isFeedbackEnabled: unwrapped.isFeedbackEnabled,
    } as GuidEventLookupDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GuidEventLookupModel, can not map to GuidEventLookupDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
